module.exports = __webpack_public_path__ + "img/dummy_tutorial.23e22c24.jpg";